import React from 'react';
import Header from 'component/layout/header/Header';
import UsersTab from './templates/usersTemplate/UsersTab';
import styles from './Users.module.scss';
import SettingsHeader from '../layout/settingsLayout/settingsHeader/SettingsHeader';
import Container from 'component/atom/container/Container';

const Users = () => {
  return (
    <Container>
      <SettingsHeader title='Users' />
      <UsersTab />
    </Container>
  );
};

export default Users;
